import { SelectBox } from 'macaron-frontend-ui'
import { useCallback } from 'react'
import {
  useCalendarQueryStatus,
  useDisplayVisitDate,
  useOpenCalendar,
} from '~/stores/calendar/state'
import { SelectBoxLoading } from './SelectBoxLoading'

export function VisitDate() {
  const { isLoading, ...props } = useVisitDateSelection()
  if (isLoading) {
    return <SelectBoxLoading />
  }
  return <SelectBox {...props} width={230} />
}

function useVisitDateSelection() {
  const visitDate = useDisplayVisitDate()
  const status = useCalendarQueryStatus()
  const openCalendar = useOpenCalendar()
  const onClick = useCallback(() => {
    openCalendar()
  }, [openCalendar])
  if (status !== 'success') {
    return { values: [], label: visitDate, onClick, disabled: false, isLoading: true }
  }
  return { values: [], label: visitDate, onClick, disabled: false, isLoading: false }
}
